exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".required{color:#fff}.required>label:after{content:\"*\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./js-src/markdown-editor/styles/required.styl
// module id = 319
// module chunks = 0 1